import axiosClient from "./axiosClient";

const extensionsApi = {
    getAll: () => {
        const url = '/extensions';

        return axiosClient.get(url, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("token")
                //'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            }
        });
    }
}

export default extensionsApi;